<template>
<div class="chapter">
<div class="inner_page">
      ﻿
<title>THE STORY DEVOTIONAL</title><link href="css/default.css" rel="stylesheet" type="text/css"/>
<p class="ctp" id="p0008-01-0"><a id="page2"></a><a href="#/contents#fn_1" id="sn_1">DAY 1</a></p>
<p class="ct"><a href="#/contents#fn_1">OUT OF NOTHING, SOMETHING</a></p>
<p class="ext"><span><i>In the beginning God created the heavens and the earth. Now the earth was formless and empty, darkness was over the surface of the deep. And God said, “Let there be light,” and there was light. </i></span></p>
<p class="txr"><span><span class="small">GENESIS</span> 1:1–3</span></p>
<p class="tx1" id="p0008-04-3"><span class="dcap">W</span>e all know the power of words. You may remember what the bully said to you on the kindergarten playground, or what one of your parents said to you in a moment of utter frustration.</p>
<p class="tx">On the other hand, maybe you remember as if it were yesterday what the coach said to let you know he believed in you. Or when your sixth-grade teacher helped you recognize in yourself an area of giftedness.</p>
<p class="tx">Human words are powerful—powerful to tear down and powerful to build up. And God’s words are infinitely more powerful. “God said”—and things happened! Where nothing had been, there was now something!</p>
<p class="tx">Consider what words God has spoken over you: you are his chosen (Colossians 3:12), loved (Ephesians 5:25), provided for (Matthew 6:32–33), protected (Psalm 18:2), child (1 John 3:1). What God speaks, happens; so live in the reality of what he says about you!</p>
<p class="tx2">LET THE CREATIVE POWER OF GOD’S WORDS RE-CREATE YOU IN CHRIST’S IMAGE.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter4.vue?613498b8